module.exports = "/_next/static/images/casebg_1-847758eb9319919d8524bd8f349cc6d2.png";